module.exports = __webpack_public_path__ + "media/sub3-6-5.845cac46.mp4";